import {Dispatch, SetStateAction, useCallback, useState} from 'react';

import useIsNotUnmounted from './useIsNotUnmounted';

/**
 * useState wrapper that only sets state if the component hasn't been unmounted.
 *
 * This avoids "Can't perform a React state update on an unmounted component" errors when passing the setState
 * callback to an async function.
 */
export default function useStateIfMounted<T>(initialValue: T | (() => T)): [T, Dispatch<SetStateAction<T>>] {
  const canSetState = useIsNotUnmounted();
  const [value, setValue] = useState(initialValue);
  const memoizedSetState = useCallback(
    (newValue: T) => {
      if (canSetState.current) {
        setValue(newValue);
      }
    },
    [canSetState]
  );
  return [value, memoizedSetState];
}
